import Annotator from "@amnstak/react-image-annotate";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Typography } from "@mui/material";
import html2canvas from "html2canvas";
import moment from "moment";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomUpload from "../../../../components/CustomUpload";
import {
  createBodyMapByAppointmentIdWoLoader,
  deleteBodyMapByIdWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";

const delBtn = { color: AppColors.red, width: 20, height: 20 };
const edtBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };

const BodyMap = () => {
  const dispatch = useDispatch();
  const annotatorRef = useRef(null);
  const [modVsble, setModVsble] = useState(false);
  const [file, setFile] = useState(null);
  const [slctedItem, setSlctedItem] = useState(null);
  const [mapVsble, setMapVsble] = useState(false);
  const [delModVsble, setDelModVsble] = useState(false);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  // useEffect(() => {
  //   callApi();
  // }, []);

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(reqDet?.appointment?.appointmentId),
    );
  };

  const onCloseCreate = () => {
    setModVsble(false);
    setFile(null);
    setMapVsble(false);
  };

  const onUploadFile = (e) => {
    const reqFile = e?.target?.files?.[0];
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFile({ file: reqFile, previewUrl: reader.result });
        setMapVsble(true);
        resolve();
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(reqFile);
    });
  };

  const handleCapture = async () => {
    if (annotatorRef.current) {
      html2canvas(annotatorRef.current).then(async (canvas) => {
        const imageData = canvas.toDataURL("image/png"); // Convert to Base64
        // Convert Base64 to Blob for API upload
        const blob = await fetch(imageData).then((res) => res.blob());
        const form = new FormData();
        form.append("petId", reqDet?.appointment?.petId);
        form.append("name", `${Date.now()}annotation.png`);
        form.append("file", blob, "annotation.png");
        dispatch(
          createBodyMapByAppointmentIdWoLoader({
            apntId: reqDet?.appointment?.appointmentId,
            form,
          }),
        ).then((res) => {
          if (res?.payload) {
            onCloseCreate();
            callApi();
          }
        });
      });
    }
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSlctedItem(null);
  };

  const onDelete = (dta) => {
    setSlctedItem(dta);
    setDelModVsble(true);
  };

  const onCofirmDelete = () => {
    if (!slctedItem?.mapId) return;
    dispatch(deleteBodyMapByIdWoLoader(slctedItem?.mapId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        callApi();
      }
    });
  };

  return (
    <>
      <div className="ph20 mt10">
        <div className="flex-row-ali-cen mh20">
          <div className="w40Per">
            <Typography className="font-bold blue-color fs12">Name</Typography>
          </div>
          <div className="w40Per">
            <Typography className="font-bold blue-color fs12">Date</Typography>
          </div>
          <div className="w20Per">
            <Typography className="font-bold blue-color fs12">
              Actions
            </Typography>
          </div>
        </div>
        <div className="blue-hor-split mt5" />
        {reqDet?.bodymaps?.length > 0
          ? reqDet?.bodymaps?.map((bm) => (
              <div className="flex-row-ali-cen mh20 mt10" key={bm?.mapId}>
                <div className="w40Per">
                  <Custom3dotString
                    str={bm?.name}
                    className="txt-semi-bold blue-color fs12 underline"
                    length={25}
                  />
                </div>
                <div className="w40Per">
                  <Typography className="font-medium gray34 fs12">
                    {moment(new Date(bm?.updatedDate)).format(
                      "DD MMM YYYY | HH:mm",
                    )}
                  </Typography>
                </div>
                <div className="w20Per">
                  <div className="flex-row-ali-cen">
                    {/* <div
                  className="cursor"
                  //  onClick={() => handleConsumEdit(li?.i)}
                >
                  <div className="flex-center">
                    <EditIcon sx={edtBtn} />
                  </div>
                  <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                    Edit
                  </Typography>
                </div> */}
                    <div className="cursor" onClick={() => onDelete(bm)}>
                      <div className="flex-center">
                        <DeleteOutlineIcon sx={delBtn} />
                      </div>
                      <Typography className="red3 fs8 txt-semi-bold text-align-center">
                        Delete
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            ))
          : null}
        {/* {reqDet?.appointment?.appointmentStatus?.toLowerCase() !==
          "completed" ||
        (reqDet?.appointment?.appointmentStatus?.toLowerCase() ===
          "completed" &&
          !reqDet?.appointment?.lock) ? ( */}
          <div
            className="flex-row-ali-cen mt20 cursor"
            onClick={() => setModVsble(true)}
          >
            <div className="flex-center plus-icon">
              <AddIcon sx={addIcon} />
            </div>
            <Typography className="blue-color fs16 ml5 font-bold">
              Add
            </Typography>
          </div>
        {/* ) : null} */}
      </div>

      <CustomModal
        open={modVsble}
        onClose={onCloseCreate}
        header="Body Map"
        modal
        modalWidth={70}
      >
        <div>
          {mapVsble && (
            <div className="scroll-80vh">
              <div ref={annotatorRef}>
                <Annotator
                  regionClsList={["One", "Two", "Three", "Four", "Five"]}
                  enabledTools={["create-point"]} // Only point tool enabled
                  selectedTool="create-point"
                  showTags
                  images={[
                    {
                      src:
                        file?.previewUrl ??
                        require("../../../../assets/images/png/bodyMapMain.png"),
                      name: "car-image-1",
                    },
                  ]}
                  onPrevImages={(state) => {
                    // console.log(state);
                  }}
                  onNextImages={(state) => {
                    // console.log(state);
                  }}
                  onExit={(output) => {
                    // console.log({ output });
                  }}
                  hideHeader={true}
                />
              </div>
              <div className="flex1-end mt20">
                <div>
                  <CustomButton text="Save" smallBtn onClick={handleCapture} />
                </div>
              </div>
            </div>
          )}
          {!mapVsble && (
            <div className="flex-row-ali-cen mb20">
              <div className="w45Per">
                <div className="dash-view h400 flex-center">
                  <div className="">
                    <CustomUpload
                      onUploadFile={onUploadFile}
                      multipleNew
                      fileAccept="image/*"
                    />
                  </div>
                </div>
              </div>
              <div className="w10Per">
                <Typography className="font-bold black fs18 text-align-center mv10">
                  or
                </Typography>
              </div>
              <div className="w45Per">
                <div
                  className="dash-view cursor"
                  onClick={() => setMapVsble(true)}
                >
                  <div className="flex-center">
                    <img
                      src={require("../../../../assets/images/png/bodyMapMain.png")}
                      alt=""
                      className="h400"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </CustomModal>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete Form"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the form?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default BodyMap;
